module.exports = __webpack_public_path__ + "assets/img/SG_001.a9338f64.jpg";